import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {getNoData, setProjectTtl} from "../../items/index.js";
import {subscribeWidget} from "../../.././main-socket/index.js";
import {WIDGET} from "../../widgetConstants.js";
import Widget from "../widget.js";
import {getProjectPostsHtmByRecord} from "./item.js";
import u from "../../../../util/index.js";

export class ProjectContentWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    async getData(props) {
        if(!this.$props.COLABO_SRNO) return true;
        //프로젝트가 들어가야하는 위젯의 경우 지정되지 않으면 true 로 반환하고 렌더링 이어서 진행.

        const inputData = {
            ...this.$props.pageData,
            GUBUN: "DETAIL",
            COLABO_SRNO: this.$props.COLABO_SRNO,
            RENEWAL_YN: "Y",
        }

        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");
        return {
            recordData: data[this.$props.RECORD]
        };
    }

    async render() {
        $(this.$target).find('.widget-article-list').html(''); //페이징 처리 후 제거
        $(this.$target).find('.widget-article-list').drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData('project'),
            callback: {
                item: getProjectPostsHtmByRecord,
                final: this.mounted.bind(this),
            }
        })
    }

    mounted() {
        super.mounted();

        $(this.$target).find('.widget-article-list').removeClass('dash-pending')
        $(this.$target).find('.dash-num-pending').remove()
        subscribeWidget({
            USER_ID: _USER_ID,
            COLABO_SRNO: this.$props.COLABO_SRNO,
            TYPE: WIDGET.PROJECT.SRNO
        })
    }

}

